import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import MaterialIcons from "../icons/MaterialIcons";
import TextView from "./TextView";
import RoundedIconButton from "./RoundedIconButton";
import { BuildContext } from "../classes/BuildContext";

type _FailureMessageViewOnClosePressed = () => void;

export interface FailureMessageViewProps extends BaseUIProps {
  key?: string;
  msg: string;
  onClosePressed?: _FailureMessageViewOnClosePressed;
}

class _FailureMessageViewState extends ObservableComponent<FailureMessageViewProps> {
  static defaultProps = { msg: "", onClosePressed: null };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: FailureMessageViewProps) {
    super(props);

    this.initState();
  }
  public get msg(): string {
    return this.props.msg;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["msg"], this.rebuild);
  }
  public componentDidUpdate(prevProps: FailureMessageViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.msg !== this.props.msg) {
      this.fire("msg", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Row({
      mainAxisAlignment: ui.MainAxisAlignment.end,
      children: [
        ui.Container({ className: "xcf9 hc vc h", key: "0" }),
        ui.Row({
          children: [
            TextView({
              data: this.msg,
              style: new ui.TextStyle({
                color: cStyle.c2,
                fontWeight: ui.FontWeight.bold,
                fontSize: 14,
              }),
              className: "x5c1 vc",
              key: "0",
            }),
            RoundedIconButton({
              icon: MaterialIcons.cancel,
              color: cStyle.c2,
              onPressed: () => {
                this.onCloseMessage();
              },
              className: "vc",
              key: "1",
            }),
          ],
          className: "x33 vc",
          key: "1",
        }),
      ],
      className: ui.join(this.props.className, "FailureMessageView hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onCloseMessage = (): void => {
    this.onClosePressed();
  };
  public get onClosePressed(): _FailureMessageViewOnClosePressed {
    return this.props.onClosePressed;
  }
}
export default function FailureMessageView(props: FailureMessageViewProps) {
  return React.createElement(_FailureMessageViewState, {
    ..._FailureMessageViewState.defaultProps,
    ...props,
  });
}
